import classNames from 'classnames';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { FC, Fragment, useEffect, useRef } from 'react';

import { CartItem, CartItemShort } from '@/entities/cart';
import { SITE_PAGES } from '@/shared/config';
import { formatPrice } from '@/shared/lib';

import styles from './cartTooltip.module.scss';

interface CartTooltipProps {
  className?: string;
  value: {
    items: CartItem[];
    count: number;
    total: number;
  };
  onClose: () => void;
  isActive: boolean;
}

const CartTooltip: FC<CartTooltipProps> = (props) => {
  const { className, value, onClose, isActive } = props;
  const { items, count, total } = value;
  const tooltipRef = useRef<HTMLDivElement>(null);
  const pathname = usePathname();

  // Закрываем баннер при изменении роута
  useEffect(() => {
    if (isActive) {
      onClose();
    }
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node) &&
        isActive
      ) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, isActive]);

  function renderCartItemShort(item: CartItem, index: number) {
    return (
      <Fragment key={index}>
        <CartItemShort item={item} />
      </Fragment>
    );
  }

  function renderCartPreview() {
    return (
      <>
        <div className={styles.tooltip__row}>
          <p className={styles.tooltip__text}>Корзина</p>
          <p className={styles.tooltip__text}>{count}</p>
        </div>
        <ul className={styles.tooltip__list}>
          {items?.map(renderCartItemShort)}
        </ul>
        <div className={styles.tooltip__footer}>
          <div className={styles.tooltip__row}>
            <p className={styles.tooltip__text}>Итого</p>
            <p className={styles.tooltip__text}>{formatPrice(total)}</p>
          </div>
          <Link
            className={classNames('button button--md-black', styles.tooltip__btn)}
            href={SITE_PAGES.cart}
            onClick={onClose}
          >
            Перейти в корзину
          </Link>
        </div>
      </>
    );
  }

  function renderEmpty() {
    return <p className={styles.tooltip__text}>В корзине пока ничего нет</p>;
  }

  return (
    <div ref={tooltipRef} className={classNames(styles.tooltip, className)}>
      <div className={styles.tooltip__wrapper}>
        {count == 0 ? renderEmpty() : renderCartPreview()}
      </div>
    </div>
  );
};

export default CartTooltip;
